import { useCallback } from 'react'

export function useEditing(setEditingState: (inEditing: boolean) => void) {
  const onEdit = useCallback(() => setEditingState(true), [setEditingState])
  const onCancel = useCallback(() => setEditingState(false), [setEditingState])

  return { onEdit, onCancel }
}
